module.exports = __webpack_public_path__ + "img/23.d470b828.svg";